export const metricCategories = Object.freeze(['home', 'discover', 'trending', 'upcoming', 'community', 'game', 'genre', 'tag', 'about', 'methodology', 'sources', 'guidelines', 'privacy', 'terms', 'saved', 'admin', 'error', 'press', 'collection']);
const pageCategories = { '/': 'home', '/discover': 'discover', '/trending': 'trending', '/upcoming': 'upcoming', '/community': 'community', '/about': 'about', '/methodology': 'methodology', '/sources': 'sources', '/guidelines': 'guidelines', '/privacy': 'privacy', '/terms': 'terms', '/saved': 'saved', '/admin': 'admin', '/press': 'press', '/collections': 'collection' };
export const validMetricGameId = value => typeof value === 'string' && (/^[1-9][0-9]{0,19}$/.test(value) || /^(?:itch-[a-f0-9]{20}|steam-[1-9][0-9]{0,9})$/.test(value) || (value.length <= 80 && /^web-[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)));

export function validMetricsPayload(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value) || !metricCategories.includes(value.category)) return false;
  if (Object.keys(value).some(key => !['category', 'gameId'].includes(key))) return false;
  return value.gameId === undefined || (value.category === 'game' && validMetricGameId(value.gameId));
}

// Only fixed categories and a game ID supplied by the successful game lookup
// leave SSR. URLs, titles, queries, forum IDs, and user details are never sent.
export function metricsConfig(config = {}, path = '/', status = 200, gameId) {
  if (config.aggregateMetricsEnabled === false) return null;
  let pathname;
  try { pathname = new URL(path, 'https://goodgamedaily.com').pathname; } catch { return null; }
  let category = pageCategories[pathname];
  if (status >= 400) category = 'error';
  else if (pathname.startsWith('/games/')) category = 'game';
  else if (pathname.startsWith('/community/')) category = 'community';
  else if (pathname.startsWith('/genres/')) category = 'genre';
  else if (pathname.startsWith('/collections/')) category = 'collection';
  else if (pathname.startsWith('/tags/')) category = 'tag';
  if (!category) return null;
  return { category, ...(category === 'game' && validMetricGameId(gameId) ? { gameId } : {}) };
}
